import { useState, FC } from 'react';
import MainContainer from '../../ui_components/MainContainer';
import { useLoaderData, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import type { Belt } from '../../../types';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px 0;

    & .title-belts-mobile {
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 2px;
        text-transform: uppercase;
        color: white;
        text-align: center;
        margin-bottom: 20px;
        font-family: CameronSansMedium, CameronSansLight, Trebuchet MS, Arial, Helvetica, Verdana, Tahoma, sans-serif;
    }
`;

const ListBeltsContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 5px;
`;

const BeltCard = styled.div`
    width: 80%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    border: 1px solid white;
    padding: 0 15px;

    & img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        object-position: top;
    }

    & h3.belt-name {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
        padding: 0 13px;
        color: white;
        text-align: center;
        width: calc(100% - 40px);
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
    }

    &:hover {
        cursor: pointer;
        transform: scale(1.05);
        transition: transform 0.3s ease-in-out;
    }
`;

interface BeltWithTeam extends Belt {
    is_team?: boolean;
}

interface BeltLoaderData {
    data: BeltWithTeam[];
}

const ListBeltsMobile: FC = () => {
    const [responseData, setResponseData] = useState<BeltLoaderData>(useLoaderData() as BeltLoaderData);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [listBelts, setListBelts] = useState<BeltWithTeam[]>(responseData.data);
    const navigate = useNavigate();


    const handleBeltClick = (belt: BeltWithTeam): void => {
        // Se belt->is_tag è true, allora navigiamo alla pagina della cintura di tag
        if(belt.is_team) {
            navigate(`/belts/tag/${belt.id}/hall-of-fame`);
        } else {
            navigate(`/belts/${belt.id}/hall-of-fame`);
        }
    }


    return (
        <MainContainer isMobile={true}>
            <Wrapper className='wrapper-belts-mobile'>
                <h2 className='title-belts-mobile'>Cinture</h2>

                <ListBeltsContainer className='list-belts-container'>
                    {listBelts.map((belt, index) => (
                        <BeltCard key={index} onClick={() => handleBeltClick(belt)}>
                            <img
                                src={process.env.REACT_APP_STORAGE_URL + belt.img_path}
                                alt={belt.img_path + "_alt"}
                            />
                            <h3 className='belt-name'>{belt.name}</h3>
                        </BeltCard>
                    ))}
                </ListBeltsContainer>
            </Wrapper>
        </MainContainer>
    )
}

export default ListBeltsMobile;
